import * as React from "react";
import { getActions } from "./actions.js";
import { reducer } from "./reducer.js";
import { getSelectors } from "./selectors.js";
import { useContactLensProductData } from "../../../../../../../../context/context/product-context-hooks.js";
import { useDeliveryIntervalOptions } from "../../../../../../components/DeliveryIntervalSelect/modules/EcommContent/components/DeliveryIntervalSelect/use-delivery-interval-options.js";
import { getInitialState } from "../../../../utils/modules/EcommContent/ContactLensesEcommContent/context/utils/get-initial-state.js";
import { triggerToastMessage } from "../../../../utils/modules/EcommContent/ContactLensesEcommContent/context/utils/trigger-toast-message.js";
const CLEcommContext = React.createContext({});
const useCLEcommContext = () => React.useContext(CLEcommContext);
const CLEcommProvider = ({
  children,
  maxOrderableQuantity: opcoConfigMaxQuantity
}) => {
  const { activeVariant, selectedPurchaseType } = useContactLensProductData();
  const { maxQuantityPerVariant, availableSubscriptionIntervals } = activeVariant;
  const { singleDeliveryIntervalOption } = useDeliveryIntervalOptions({
    deliveryInterval: null,
    availableSubscriptionIntervals
  });
  const maxOrderableQuantity = !!maxQuantityPerVariant ? maxQuantityPerVariant : opcoConfigMaxQuantity;
  const getInitialStateProps = {
    purchaseType: selectedPurchaseType,
    sortedAttributesSet: activeVariant.prescriptionRanges,
    defaultDeliveryInterval: singleDeliveryIntervalOption?.value,
    maxOrderableQuantity
  };
  const [state, dispatch] = React.useReducer(reducer, getInitialStateProps, getInitialState);
  const actions = React.useMemo(() => getActions(dispatch), []);
  const selectors = React.useMemo(() => getSelectors(), []);
  React.useEffect(() => {
    actions.updatePurchaseType(selectedPurchaseType);
  }, [actions, selectedPurchaseType]);
  React.useDebugValue("CLEcommProvider");
  const value = React.useMemo(
    () => ({
      actions,
      state,
      selectors,
      maxOrderableQuantity,
      triggerToastMessage
    }),
    [actions, state, selectors, maxOrderableQuantity]
  );
  return /* @__PURE__ */ React.createElement(CLEcommContext.Provider, { value }, children);
};
export {
  CLEcommContext,
  CLEcommProvider,
  useCLEcommContext
};
//# sourceMappingURL=CLEcommContext.js.map
